const bodyContainer = document.querySelector(".body-container");
const watchVideoButton = document.querySelector(".site-video__button");
const videoModal = document.querySelector(".site-video__modal");
const videoSlider = document.querySelector(".site-video__slider");
let swiper;

if (videoSlider && window.matchMedia("(max-width: 540px)").matches) {
  swiper = new Swiper(".swiper-container.site-video__slider", {
    loop: true,
  });
}

if (watchVideoButton) {
  watchVideoButton.addEventListener("click", () => {
    bodyContainer?.classList.add("body-container--no-scroll");
    videoModal?.classList.add("site-modal--opened");
  });
}
